import success from '~/assets/icons/success.svg';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { IExchangeItem, rage, useObservable } from '~/rage';
import { setFinishScreenVisible, useLayoutDispatch } from '../../redux';
import { FinishScreenItem } from '../FinishScreenItem';
import {
	StyledBg,
	StyledBgCircle,
	StyledContainer,
	StyledItemsContainer,
	StyledResultContainer,
} from './FinishScreen.styled';

const FinishScreen = () => {
	const dispatch = useLayoutDispatch();
	const otherPlayerName = useObservable(rage.exchange.getOtherPlayerName());
	const otherPlayerPlacedItems = useObservable(
		rage.exchange.getOtherPlayerPlacedItems(),
	);

	return (
		<StyledContainer>
			<StyledBg />
			<StyledBgCircle />
			<StyledResultContainer>
				<img src={success} width={30} height={30} />
				<Text style={{ fontSize: 18, fontWeight: 500, color: '#ffffff' }}>
					Обмен успешно завершен!
				</Text>
				<Text style={{ fontSize: 16, color: 'rgba(255, 255, 255, 0.5)' }}>
					При обмене с игроком{' '}
					<span style={{ color: '#ffffff' }}>{otherPlayerName}</span> вы
					получили:
				</Text>
				<StyledItemsContainer>
					{otherPlayerPlacedItems.map((item, index) => (
						<FinishScreenItem item={item as IExchangeItem} key={index} />
					))}
				</StyledItemsContainer>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height40}
					onClick={() => dispatch(setFinishScreenVisible(false))}
					style={{ width: 131 }}
				>
					<Text>Продолжить</Text>
				</Button>
			</StyledResultContainer>
		</StyledContainer>
	);
};

export { FinishScreen };
